// config.ts
import { StyleSheet, ViewStyle } from 'react-native';

const config = {
  theme: {
    colors: {
        black: '#181818ff',
        lightGreen: '#00A80E',
        white: '#FFFFFF',
        gray: '#b1b1b1ff',
        redColor: '#F00',
        yellow: '#f0ca0bff',
        lightGray: '#e4e4e4ff',
        darkGray: '#424242ff',
        cloverConnected: '#4DAF18',
        cloverDisconnected: '#CE1C1C',
        cloverUnstable: '#DF520C',
      },
    },
}

type ConfigType = typeof config;

declare global {
  var config: ConfigType;
}

globalThis.config = config;

const { colors } = config.theme;

export { colors };

